module.exports = __webpack_public_path__ + "media/images/flags/64/Malta-3d4b50a02bdc26b37c50790366fc408e.png";